// @ts-nocheck
import {Column} from 'react-table'

import {CreatedInCell} from './CreatedInCell'
import {SelectionCell} from './SelectionCell'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {User} from '../../core/_models'
import {NameCell} from './NameCell'
import {EmailCell} from './EmailCell'
import {CpfCell} from './CpfCell'
import {StatusCell} from './StatusCell'
import {PhoneCell} from './PhoneCell'
import {FranchisesCell} from './FranchisesCell'
import {RolesCell} from './RolesCell'

const UserColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <SelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Nome' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <NameCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='CPF' className='min-w-125px' />,
    id: 'cpf_user',
    Cell: ({...props}) => <CpfCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Telefone' className='min-w-125px' />,
    id: 'phone_user',
    Cell: ({...props}) => <PhoneCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='E-mail' className='min-w-125px' />,
    id: 'email_user',
    Cell: ({...props}) => <EmailCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Franquias' className='min-w-150px' />,
    id: 'franchises',
    Cell: ({...props}) => <FranchisesCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Grupo' className='min-w-100px' />,
    id: 'roles',
    Cell: ({...props}) => <RolesCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-50px' />,
    id: 'active_user',
    Cell: ({...props}) => <StatusCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Criado em' className='min-w-125px' />,
    id: 'data',
    Cell: ({...props}) => <CreatedInCell user={props.data[props.row.index]} />,
  },
]

export {UserColumns}
